// Maps spoken phrases to in-app navigation targets and actions.
// Keywords are ordered most-specific first so e.g. "use case library" matches
// before the bare "library".
export const NAV_TARGETS = [
  { path: '/app', label: 'Dashboard', keywords: ['dashboard', 'home page', 'main page', 'overview', 'home'] },
  { path: '/app/leaderboard', label: 'the Leaderboard', keywords: ['leaderboard', 'leader board', 'rankings', 'ranking', 'standings'] },
  { path: '/app/quests', label: 'the Quest Board', keywords: ['quest board', 'quests', 'quest', 'missions', 'mission'] },
  { path: '/app/contributions', label: 'Contributions', keywords: ['contributions', 'contribution', 'bounties', 'bounty', 'submissions'] },
  { path: '/app/library', label: 'the Use Case Library', keywords: ['use case library', 'use cases', 'use case', 'library'] },
  { path: '/app/pods', label: 'Pods', keywords: ['pods', 'pod'] },
  { path: '/app/interns', label: 'the Intern Program', keywords: ['intern program', 'interns', 'intern', 'tasks', 'task board'] },
  { path: '/app/faq', label: 'the FAQ', keywords: ['faqs', 'faq', 'frequently asked', 'help page'] },
  { path: '/app/members', label: 'Members', keywords: ['members', 'member', 'team directory', 'the team'], admin: true },
];

const NAV_VERBS = /\b(go to|goto|open|show me|show|navigate to|navigate|take me to|take me|bring up|switch to|switch|move to|display|pull up|view|let'?s see)\b/;

// Returns a command object ({ type: 'navigate' | 'logout' | 'closeChat', ... })
// or null when the transcript is a normal question for JARVIS.
export function parseCommand(transcript, { isAdmin = false } = {}) {
  if (!transcript) return null;
  const t = transcript.toLowerCase().trim();

  if (/\b(log ?out|sign ?out|log me out|sign me out)\b/.test(t)) return { type: 'logout' };
  if (/\b(close|hide|dismiss|minimi[sz]e)\b.*\b(chat|assistant|jarvis|window|panel)\b/.test(t)) {
    return { type: 'closeChat' };
  }

  const hasNavVerb = NAV_VERBS.test(t);
  const wordCount = t.split(/\s+/).length;

  for (const target of NAV_TARGETS) {
    if (target.admin && !isAdmin) continue;
    if (target.keywords.some(k => t.includes(k))) {
      // Require a navigation verb, or a very short phrase like "leaderboard",
      // so that questions ("how many points on the leaderboard?") fall through
      // to JARVIS instead of triggering navigation.
      if (hasNavVerb || wordCount <= 3) {
        return { type: 'navigate', path: target.path, label: target.label };
      }
    }
  }

  return null;
}
